import { render, staticRenderFns } from "./ChooseWaveModal.vue?vue&type=template&id=98817abe&scoped=true"
import script from "./ChooseWaveModal.vue?vue&type=script&lang=js"
export * from "./ChooseWaveModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseWaveModal.vue?vue&type=style&index=0&id=98817abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98817abe",
  null
  
)

export default component.exports